import axios from 'axios'

export const state = {
  campaignActivity: [],
  loading: false,
}

export const getters = {
  campaignActivity: (state) => state.campaignActivity,
  loading: (state) => state.loading,
}

export const mutations = {
  SET_CAMPAIGN_ACTIVITY(state, payload) {
    state.campaignActivity = payload
  },
  SET_ACTIVITY_LOADING(state, payload) {
    state.loading = payload
  },
}

export const actions = {
  async getCampaignActivity({ commit }, id) {
    commit('SET_ACTIVITY_LOADING', true)
    try {
      const { data } = await axios.get(`/api/social-products/social-boost/activity/campaign/${id}`)
      commit('SET_CAMPAIGN_ACTIVITY', data)
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_ACTIVITY_LOADING', false)
    }
  },
}
